"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asDefined = void 0;
/**
 * @summary Asserts that a value is not null and returns it.
 *
 * Asserts that a value is not null or undefined. If the value is defined, it will be returned. If it is
 * not defined, a `TypeError` is thrown.
 *
 * @param {any} value
 * @returns {any}
 * @throws {TypeError} The value was `undefined` or `null`.
 *
 * @example
 * const { loading, data } = useQuery();
 * if (loading) {
 *   return <CircularProgress />;
 * }
 * return <Display data={asDefined(data)} />;
 */
function asDefined(value) {
    if (value == null) {
        throw new TypeError('Expected value to be defined.');
    }
    return value;
}
exports.asDefined = asDefined;
